<template>
  <div class="psychological-month-report">
    <!--顶部栏-->
    <ReportHeader
      :schoolName="schoolName"
      :exportPdfLoading="exportPdfLoading"
      @exportReport="exportReportPdf"
      @changeMonth="changeMonth"
    />
    <!--占位-->
    <div style="height: 90px"></div>
    <!--内容区域-->
    <div ref="monthReportMainBody" class="main-body">
      <!--本月概览-->
      <CurrMonthOverview
        :dateRange="dateRange"
        :faceCollectInfo="faceCollectInfo"
        :schoolName="schoolName"
        :dataSource="currMonthOverviewObj"
      />
      <!--相机采集数据-->
      <CameraAcquisition
        :dateRange="dateRange"
        :dataSource="cameraAcquisitionObj"
        style="margin-top: 30px"
      />
      <!--情绪指数分析-->
      <SentimentAnalysis :dateRange="dateRange" style="margin-top: 30px" />
      <!--全校提醒名单人数变化趋势 -->
      <RemindListTrend :dateRange="dateRange" style="margin-top: 30px" />

      <!--重点学生管理-->
      <MainStudentManagement
        :dateRange="dateRange"
        :currMonthInfo="currMonthInfo"
        :cardInfo="mainStudentCardInfo"
        style="margin-top: 30px"
      />
      <!--多次提醒学生班主任关怀情况-->
      <RemindCaringSituation
        :dateRange="dateRange"
        :dataSourceExtra="remindCaringExtra"
        style="margin-top: 30px"
      />
      <!--教师使用数据-->
      <TeacherUseData
        :dateRange="dateRange"
        :overallUsageInfo="overallUsageInfo"
        style="margin-top: 30px"
      />
      <!--心理老师使用数据-->
      <PsychologicalTeachersUse
        ref="psychologicalTeachersUseRef"
        :dateRange="dateRange"
        :coachingCoreInfo="coachingCoreInfo"
        :faceCollectInfo="faceCollectInfo"
        style="margin-top: 30px"
      />
      <!-- 全校情绪健康特征分析 -->
      <WholeSchoolEmotionAnalysis :dateRange="dateRange" style="margin-top: 30px" />

      <!--底部背景文本-->
      <!-- <FootCard style="margin-top: 30px" /> -->
    </div>
    <!--回到顶部-->
    <a-back-top :target="targetFn" :visibilityHeight="400" />
  </div>
</template>
<script>
import ReportHeader from './components/ReportHeader'
import CurrMonthOverview from './components/CurrMonthOverview.vue'
import CameraAcquisition from './components/CameraAcquisition.vue'
import SentimentAnalysis from './components/SentimentAnalysis/index.vue'
import WholeSchoolEmotionAnalysis from './components/WholeSchoolEmotionAnalysis.vue'
import RemindListTrend from './components/RemindListTrend.vue'
import MainStudentManagement from './components/MainStudentManagement.vue'
import RemindCaringSituation from './components/RemindCaringSituation.vue'
import TeacherUseData from './components/TeacherUseData/index.vue'
import PsychologicalTeachersUse from './components/PsychologicalTeachersUse/index.vue'
import FootCard from './components/FootCard.vue'
import {
  querySchoolEmotionMoodTrend,
  queryStudentsWithoutFaceStatistics,
  getMoodContinuedLowModelCount,
} from '@/api/monthReport'
import { ExportToPdf } from '@/mixins/ExportToPdf'

export default {
  name: 'PsychologicalMonthReport',
  mixins: [ExportToPdf],
  components: {
    ReportHeader,
    CurrMonthOverview,
    CameraAcquisition,
    SentimentAnalysis,
    WholeSchoolEmotionAnalysis,
    RemindListTrend,
    MainStudentManagement,
    RemindCaringSituation,
    TeacherUseData,
    PsychologicalTeachersUse,
    FootCard,
  },
  data() {
    return {
      schoolName: '',
      exportPdfLoading: false,
      dateRange: {},
      currMonthInfo: {},
      // 设置默认值防止初始化时为空
      currMonthOverviewObj: {
        schoolAvgEmotionValue: 0,
        schoolHistoryAvgEmotionValueStr: '',
        gradeEmotionTop: '-',
        gradeEmotionTopValue: 0,
        gradeEmotionLow: '-',
        gradeEmotionLowValue: 0,
        remindStudentCount: 0,
        twoRemindStudentCount: 0,
        threeRemindStudentCount: 0,
        moodContinuedLowModelStudentCount: 0,
        mentalWorkloadCount: 0,
        crisisReportStudentCount: 0,
        dealFullMarksTopClassNameStr: '',
        remindDealRate: 0, //提醒处理率
        remindNotDealRate: 0 //提醒未处理率
      },
      cameraAcquisitionObj: {
        coverageRate: 0,
        studentFaceCount: 0,
        cameraStudentFaceCount: 0,
      },
      mainStudentCardInfo: {
        remindStudentCount: 0,
        twoRemindStudentCount: 0,
        twoRemindStudentRate: 0,
        threeRemindStudentCount: 0,
        threeRemindStudentRate: 0,
        careStudentRemindCount: 0,
        careStudentRemindRate: 0,
      },
      remindCaringExtra: {
        twoManyRemindStudentCount: 0,
        twoManyRemindStudentCareHaveDealCount: 0,
        twoManyRemindStudentCareRate: 0,
        twoManyRemindStudentCareNotAllDealCount: 0,
        twoManyRemindStudentCareNotAllDealRate: 0,
        twoManyRemindStudentCareDealOnceCount: 0,
        twoManyRemindStudentCareNotDealCount: 0,
      },
      overallUsageInfo: {},
      userClassInfo: {},
      coachingCoreInfo: {},
      // 学生采集信息
      faceCollectInfo: {
        faceNotGatherCount: 0,
        haveFaceNotGather: 0,
        withOutFaceNotGather: 0,
      },
    }
  },
  created() {},
  methods: {
    async changeMonth(dataObj) {
      this.dateRange = {
        beginDate: dataObj.beginDate,
        endDate: dataObj.endDate,
      }
      this.currMonthInfo = dataObj.currMonthInfo
      this.queryStudentsWithoutFaceStatistics()
      this.getMoodContinuedLowModelCount()
      await this.querySchoolEmotionMoodTrend(this.dateRange)
      // 心理辅导核心数据需要用到全部参数中的危机上报数据
      this.$refs.psychologicalTeachersUseRef.getStudentCounselingDataByTime()
    },
    targetFn() {
      return document.querySelector('.outer-layer-roll')
    },
    async querySchoolEmotionMoodTrend(dateObj) {
      const { success, result } = await querySchoolEmotionMoodTrend({
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      })
      if (!success) return
      const {
        schoolName,
        schoolAvgEmotionValue,
        schoolHistoryAvgEmotionValueStr,
        gradeEmotionTop,
        gradeEmotionTopValue,
        gradeEmotionLow,
        gradeEmotionLowValue,
        remindStudentCount,
        twoRemindStudentCount,
        twoRemindStudentRate,
        threeRemindStudentCount,
        threeRemindStudentRate,
        careStudentRemindCount,
        careStudentRemindRate,
        mentalWorkloadCount,
        crisisReportStudentCount,
        dealFullMarksTopClassNameStr,
        // ------------------------
        coverageRate,
        studentFaceCount,
        cameraStudentFaceCount,
        // ------------------------
        twoManyRemindStudentCount,
        twoManyRemindStudentCareRate,
        twoManyRemindStudentCareHaveDealCount,
        twoManyRemindStudentCareNotAllDealCount,
        twoManyRemindStudentCareNotAllDealRate,
        twoManyRemindStudentCareNotDealCount,
        twoManyRemindStudentCareDealOnceCount,
        // ------------------------
        dealRate,
        dealRateDiff,
        excellentDealRate,
        excellentDealRateDiff,

        remindDealRate,
        remindNotDealRate,
      } = result
      this.schoolName = schoolName
      // 本月概览
      this.currMonthOverviewObj = {
        ...this.currMonthOverviewObj,
        schoolAvgEmotionValue,
        schoolHistoryAvgEmotionValueStr,
        gradeEmotionTop,
        gradeEmotionTopValue,
        gradeEmotionLow,
        gradeEmotionLowValue,
        remindStudentCount,
        twoRemindStudentCount,
        threeRemindStudentCount,
        mentalWorkloadCount,
        crisisReportStudentCount,
        dealFullMarksTopClassNameStr,
        remindDealRate,
        remindNotDealRate
      }
      // 相机采集数据
      this.cameraAcquisitionObj = {
        coverageRate,
        studentFaceCount,
        cameraStudentFaceCount,
      }
      // 重点学生管理-提醒情况总数及构成情况
      this.mainStudentCardInfo = {
        remindStudentCount,
        twoRemindStudentCount,
        twoRemindStudentRate,
        threeRemindStudentCount,
        threeRemindStudentRate,
        careStudentRemindCount,
        careStudentRemindRate,
      }
      // 多次提醒学生班主任关怀情况额外数据
      this.remindCaringExtra = {
        twoManyRemindStudentCount,
        twoManyRemindStudentCareHaveDealCount,
        twoManyRemindStudentCareRate,
        twoManyRemindStudentCareNotAllDealCount,
        twoManyRemindStudentCareNotAllDealRate,
        twoManyRemindStudentCareDealOnceCount,
        twoManyRemindStudentCareNotDealCount,
      }
      // 教师使用数据-整体使用情况
      this.overallUsageInfo = {
        dealRate,
        dealRateDiff: Number(dealRateDiff),
        excellentDealRate,
        excellentDealRateDiff: Number(excellentDealRateDiff),
      }
      // 心理老师使用数据-心理辅导核心数据-危机上报
      this.coachingCoreInfo = {
        crisisReportStudentCount,
      }
    },
    async queryStudentsWithoutFaceStatistics() {
      const { success, result } = await queryStudentsWithoutFaceStatistics({
        startTime: this.dateRange.beginDate,
        endTime: this.dateRange.endDate,
      })
      if (success) {
        this.faceCollectInfo = result
      }
    },
    async getMoodContinuedLowModelCount() {
      const { success, result } = await getMoodContinuedLowModelCount({
        startTime: this.dateRange.beginDate,
        endTime: this.dateRange.endDate,
      })
      if (success) {
        this.$set(this.currMonthOverviewObj, 'moodContinuedLowModelStudentCount', result)
        console.log(
          'moodContinuedLowModelStudentCount',
          this.currMonthOverviewObj.moodContinuedLowModelStudentCount
        )
      }
    },
    // 导出报告
    exportReportPdf(title) {
      this.exportLongImgToPdf(this.$refs.monthReportMainBody, title, {
        backgroundColor: '#f5f5f5',
      })
    },
  },
}
</script>
<style scoped lang="less">
.psychological-month-report {
  margin: -12px -12px 0px;
  background-color: #f0f2f5;
  //height: 100vh;
  //overflow-y: auto;
  font-size: 14px;
  .main-body {
    padding: 20px;
  }
  /deep/ .ant-back-top {
    right: 50px !important;
    z-index: 99;
  }
}
</style>
